module.exports = __webpack_public_path__ + "img/88.d6859b0f.png";